// LogoForm.tsx
import React from "react";

import { Business } from "0.Mine/3.Interfaces/business";

import { useLogoFormLogic } from "../../Logic/BasicInfo/Logo";
import LogoFormUI from "../../UI/LogoFormUI";

interface LogoFormProps {
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

const LogoForm: React.FC<LogoFormProps> = ({ updateBusinessData, businessData }) => {
  const {
    logo,
    banner,
    bannerString,
    logoString,
    handleLogoChange,
    handleBannerChange,
    handleBannerDelete,
    handleLogoDelete,
  } = useLogoFormLogic({ updateBusinessData, businessData });

  return (
    <LogoFormUI
      handleBannerDelete={handleBannerDelete}
      handleLogoDelete={handleLogoDelete}
      logo={logo}
      banner={banner}
      logoString={logoString}
      bannerString={bannerString}
      handleBannerChange={handleBannerChange}
      handleLogoChange={handleLogoChange}
    />
  );
};

export default LogoForm;
